import { SvgProps } from "../Form";

export const FileEditIcon = (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_7234_2158)">
      <path
        d="M10.9742 5.83333C11.1545 5.83333 11.3248 5.74992 11.4351 5.60758C11.5453 5.46525 11.5838 5.27975 11.5395 5.10533C11.3581 4.39542 10.9882 3.74675 10.4702 3.22875L8.43733 1.19583C7.66617 0.424667 6.64067 0 5.54983 0H2.91608C1.30842 0 0 1.30842 0 2.91667V11.0833C0 12.6916 1.30842 14 2.91667 14H4.66667C4.98867 14 5.25 13.7387 5.25 13.4167C5.25 13.0947 4.98867 12.8333 4.66667 12.8333H2.91667C1.95183 12.8333 1.16667 12.0482 1.16667 11.0833V2.91667C1.16667 1.95183 1.95183 1.16667 2.91667 1.16667H5.55042C5.6455 1.16667 5.74 1.17133 5.83333 1.18008V4.08333C5.83333 5.04817 6.6185 5.83333 7.58333 5.83333H10.9742ZM7 4.08333V1.55108C7.22108 1.67825 7.427 1.83575 7.6125 2.02125L9.64542 4.05417C9.82858 4.23733 9.9855 4.44383 10.1138 4.66667H7.58333C7.26192 4.66667 7 4.40475 7 4.08333ZM13.4878 6.92942C12.8263 6.26792 11.6737 6.26792 11.0127 6.92942L7.10033 10.8418C6.65992 11.2823 6.41667 11.8685 6.41667 12.4921V13.4173C6.41667 13.7393 6.678 14.0006 7 14.0006H7.92517C8.54875 14.0006 9.13442 13.7573 9.57483 13.3169L13.4872 9.4045C13.818 9.07375 14 8.6345 14 8.16667C14 7.69883 13.818 7.25958 13.4878 6.92942ZM12.6624 8.57908L8.74942 12.4915C8.5295 12.712 8.23667 12.8333 7.92458 12.8333H7.58275V12.4915C7.58275 12.18 7.70408 11.8872 7.92458 11.6667L11.8376 7.75425C12.0575 7.53375 12.4419 7.53375 12.6624 7.75425C12.7727 7.86392 12.8333 8.01033 12.8333 8.16667C12.8333 8.323 12.7727 8.46883 12.6624 8.57908Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7234_2158">
        <rect width="14" height="14" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
